import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiFetch } from '../../utils/api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ScormPlayer.css';

const ScormPlayer = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [iframeLoading, setIframeLoading] = useState(true); // New state for iframe load
  const [error, setError] = useState(null);
  const [courseTitle, setCourseTitle] = useState('');

  // Verify enrollment and get course info
  useEffect(() => {
    const verifyAccess = async () => {
      try {
        setLoading(true);
        // Just verify we can access the course (this will fail if not enrolled)
        const data = await apiFetch(
          `${window._env_.API_BASE_URL}/scorm/courses/${courseId}/launch`
        );
        setCourseTitle(data.title || 'SCORM Course');
        setLoading(false);
      } catch (err) {
        console.error('Error verifying course access:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    verifyAccess();
  }, [courseId]);

  const handleIframeLoad = () => {
    setIframeLoading(false);
  };

  // Get the token for the iframe URL
  const getToken = () => {
    return localStorage.getItem('token') || localStorage.getItem('access_token') || '';
  };

  // Build the player URL - this loads the backend-hosted SCORM player
  // The backend serves HTML with the SCORM API embedded, avoiding cross-origin issues
  const getPlayerUrl = () => {
    const token = getToken();
    // The backend player endpoint serves the SCORM content through a proxy
    return `${window._env_.API_BASE_URL}/scorm/player/${courseId}?token=${encodeURIComponent(token)}`;
  };

  if (loading) {
    return (
      <div className="scorm-player-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading SCORM Course...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="scorm-player-page">
        <div className="error-container">
          <span className="error-icon">⚠️</span>
          <h2>Failed to Load Course</h2>
          <p>{error}</p>
          <button onClick={() => navigate('/scorm')} className="back-btn">
            Back to Courses
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="scorm-player-page fullscreen-player">
      <ToastContainer />

      {(loading || iframeLoading) && (
        <div className="loading-overlay">
          <div className="loading-content">
            <div className="loading-spinner"></div>
            <p>Please wait, loading SCORM course...</p>
          </div>
        </div>
      )}

      {/* The backend serves a complete HTML page with SCORM API embedded */}
      {!loading && (
        <iframe
          src={getPlayerUrl()}
          title={courseTitle}
          className="scorm-fullpage-iframe"
          allow="fullscreen"
          onLoad={handleIframeLoad}
          style={{ visibility: iframeLoading ? 'hidden' : 'visible' }}
        />
      )}
    </div>
  );
};

export default ScormPlayer;
